import React, { useCallback, useEffect } from 'react';
import { useDetailViewContext } from '../context/DetailViewContext';
import { DetailSectionIDs } from '../data/Sections';
import { useAudioContext } from '../context/AudioContext';
import FocusPoints from '../data/FocusPoints';

export default function KeystrokeController(): JSX.Element
{
  const { setDetailSectionID,setActiveFocusID } = useDetailViewContext();
  const { muteBGM, muteGlobal } = useAudioContext();

  const onKeyUp = useCallback((event: KeyboardEvent) =>
  {
    switch (event.key) {
    case ' ':
      setActiveFocusID(FocusPoints.None);
      break;
    case 'Escape':
      // setActiveFocusID(FocusPoints.None);
      setDetailSectionID(DetailSectionIDs.None);
      break;
    case '1':
      setDetailSectionID(DetailSectionIDs.DecodingVector);
      break;
    case '2':
      setDetailSectionID(DetailSectionIDs.DecodingSphere);
      break;
    case '3':
      setDetailSectionID(DetailSectionIDs.DecodingSubspaces);
      break;
    case '4':
      setDetailSectionID(DetailSectionIDs.DecodingTopology);
      break;
    case '5':
      setDetailSectionID(DetailSectionIDs.DecodingDynamicBehaviour);
      break;
    case 'm':
      muteBGM(value => !value);
      break;
    case 'g':
      muteGlobal(value => !value);
      break;
    }
  }, [muteBGM, muteGlobal, setActiveFocusID, setDetailSectionID]);

  useEffect(() =>
  {
    document.addEventListener('keyup', onKeyUp);
    return () =>
    {
      document.removeEventListener('keyup', onKeyUp);
    };
  }, [ onKeyUp ]);
  return <></>;
}